
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 22.5h-21A1.5 1.5 0 010 21v-8a.5.5 0 011 0v8a.5.5 0 00.5.5h21a.5.5 0 00.5-.5v-8a.5.5 0 011 0v8a1.5 1.5 0 01-1.5 1.5z"}}),_c('path',{attrs:{"d":"M12 16.5a.5.5 0 01-.5-.5V2.89a.5.5 0 011 0V16a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M17 7.6a.5.5 0 01-.36-.16L12 2.71 7.36 7.44a.5.5 0 11-.72-.7l5-5.09a.52.52 0 01.72 0l5 5.1a.5.5 0 01-.36.84z"}})])
          )
        }
      }
    